export default "<div class=\"footer\">\n\t<p>Footer</p>\n</div>\n"